import angular from 'angular';

import '@nuskin/ns-common-angularjs';
import {default as orderSummary} from './views/orderSummary.html';
import {default as adrShipWhen} from './views/adrShipWhen.html';
import {default as orderConfirmation} from './views/orderConfirmation.html';
import {default as fatalError} from './views/fatalError.html';
import {default as version} from './views/version.html';
import {default as downtime} from './views/downtime.html';
import {default as externalPayment} from './views/externalPayment.html';

import 'angular-route';
import 'angular-spinner';
import 'angular-resource';
import 'angular-cookies';
import 'angular-touch';
import 'angular-animate';
import 'angular-sanitize';
import 'angular-ui-mask';
import {events} from '@nuskin/ns-util';

angular.module('checkout', [
    'ngRoute',
    'angularSpinner',
    'ngResource',
    'ngCookies',
    'ngTouch',
    'ngAnimate',
    'ngSanitize',
    'nsUtil',
    'nsShop',
    'nsAccount',
    'ui.mask'
]);

// eslint-disable-next-line max-len
angular.module('checkout').config(['$routeProvider', '$httpProvider', 'uiMask.ConfigProvider', function($routeProvider, $httpProvider, uiMaskConfigProvider) {
    uiMaskConfigProvider.clearOnBlur(false);
    // eslint-disable-next-line
    // let checkoutPageUri = checkoutPageUrl;
    // eslint-disable-next-line
    // if (checkoutPageUrl === undefined) {
    // const currentPageUrl = window.location.href;
    // const indexOfCheckoutUri = currentPageUrl.indexOf('checkout');
    // const checkoutPageUri = currentPageUrl.substring(0, indexOfCheckoutUri) + 'checkout';
    // }

    $routeProvider
        .when('/', {
            template: orderSummary,
            controller: 'OrderSummaryCtrl'
        })
        .when('/:locale/orderSummary', {
            template: orderSummary,
            controller: 'OrderSummaryCtrl'
        })
        .when('/:locale/mysite/orderSummary', {
            template: orderSummary,
            controller: 'OrderSummaryCtrl'
        })
        .when('/:locale/adrShipWhen', {
            template: adrShipWhen,
            controller: 'AdrShipWhenCtrl'
        })
        .when('/:locale/mysite/adrShipWhen', {
            template: adrShipWhen,
            controller: 'AdrShipWhenCtrl'
        })
        .when('/:locale/orderconfirmation', {
            template: orderConfirmation,
            controller: 'OrderConfirmationCtrl'
        })
        .when('/:locale/mysite/orderconfirmation', {
            template: orderConfirmation,
            controller: 'OrderConfirmationCtrl'
        })
        .when('/:locale/externalPayment', {
            template: externalPayment,
            controller: 'ExternalPaymentCtrl'
        })
        .when('/:locale/downtime', {
            template: downtime,
            controller: 'DowntimeCtrl'
        })
        .when('/:locale/fatalError', {
            template: fatalError,
            controller: 'fatalErrorCtrl'
        })
        .when('/version', {
            template: version,
            controller: 'versionCtrl'
        })
        .otherwise({redirectTo: '/en_US/orderSummary'});
}]);

angular.module('checkout').run(['$rootScope', function($rootScope) {
    $rootScope.$on('$locationChangeStart', function(event, next, current) {
        events.publish(events.shop.CHECKOUT_ROUTE_CHANGING, {next: next, current: current});
    });
}]);
